import { render } from "./Parteneri.vue?vue&type=template&id=55a3cc65"
import script from "./Parteneri.vue?vue&type=script&lang=js"
export * from "./Parteneri.vue?vue&type=script&lang=js"

import "./Parteneri.vue?vue&type=style&index=0&id=55a3cc65&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__